import { Link } from "react-router-dom";
import { detailedServices } from "../../mocks/home-data";
import FadeIn from "../../components/base/FadeIn";
import PageHero from "../../components/feature/PageHero";

export default function Services() {
  return (
    <main>
      <PageHero
        badge="Hizmetlerimiz"
        title={
          <>
            Kapsamlı{" "}
            <span className="font-serif italic text-primary-300">Veteriner</span>
            <br />
            Hizmetleri
          </>
        }
        description="Modern ekipmanlarımız ve özenli ekibimizle dostlarınıza en iyi bakımı sunuyoruz. Her hizmet alanında deneyimli veteriner hekimlerimiz görev alıyor."
        backgroundImage="/assets/images/svc-hero-bg.jpg"
      />

      {/* Services Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-16 md:space-y-24">
              {detailedServices.map((service, index) => (
                <FadeIn key={service.id} delay={0.1}>
                  <div className={`grid lg:grid-cols-2 gap-8 lg:gap-16 items-center ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
                    {/* Image */}
                    <div className={`${index % 2 === 1 ? "lg:order-2" : ""}`}>
                      <div className="relative rounded-3xl overflow-hidden shadow-xl group">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full object-cover aspect-[4/3] transition-transform duration-700 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/30 via-transparent to-transparent" />
                        {service.highlight && (
                          <div className="absolute top-4 left-4 px-4 py-2 bg-primary-600 text-white text-sm font-semibold rounded-xl shadow-lg">
                            Öne Çıkan Hizmet
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Content */}
                    <div className={`${index % 2 === 1 ? "lg:order-1" : ""}`}>
                      <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-6">
                        <i className={`${service.icon} text-3xl text-primary-700 w-8 h-8 flex items-center justify-center`} />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                        {service.title}
                      </h2>
                      <p className="text-gray-600 leading-relaxed mb-6 text-lg">
                        {service.description}
                      </p>
                      <div className="grid sm:grid-cols-2 gap-3">
                        {service.features.map((feature) => (
                          <div key={feature} className="flex items-center gap-3 bg-cream-50 rounded-xl px-4 py-3">
                            <i className="ri-check-line w-5 h-5 flex items-center justify-center text-primary-600 shrink-0" />
                            <span className="text-sm text-gray-700 font-medium">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-primary-950">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto text-center">
            <FadeIn>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                Dostlarınız İçin En İyi Bakım
              </h2>
              <p className="text-white/70 mb-8 max-w-2xl mx-auto text-lg">
                Hizmetlerimiz hakkında detaylı bilgi almak ve randevu oluşturmak için bizi arayın. 
                Ekibimiz size yardımcı olmaktan mutluluk duyacaktır.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="tel:05396960677"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-bold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                >
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                  0539 696 06 77
                </a>
                <Link
                  to="/iletisim"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl border border-white/20 transition-all duration-300 whitespace-nowrap"
                >
                  İletişime Geç
                </Link>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </main>
  );
}
